import React, { useState } from "react";
import { Loader2, Mail, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function NewsletterSignup({ source = "blog" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email: email.trim(), source });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Inscription impossible, réessayez.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-3xl border border-brand-soft bg-brand-softer p-7" data-testid="newsletter-signup">
      {done ? (
        <div className="flex items-center gap-3 text-brand-greenDeep" data-testid="newsletter-done">
          <CheckCircle2 className="w-6 h-6 text-emerald-600 flex-shrink-0" />
          <div>
            <p className="font-semibold">Merci, c'est noté !</p>
            <p className="text-sm text-brand-green/65">Vous recevrez nos meilleurs conseils de gestion locative par e-mail.</p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center flex-shrink-0"><Mail className="w-5 h-5" /></div>
            <div>
              <h3 className="font-display text-xl font-semibold text-brand-greenDeep">La newsletter du bailleur</h3>
              <p className="text-sm text-brand-green/65">Conseils, guides et actualités de la gestion locative, une fois par mois. Sans spam.</p>
            </div>
          </div>
          <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre adresse e-mail"
              className="flex-1 px-4 py-3 rounded-full border border-brand-soft bg-white outline-none focus:border-brand-lime text-sm text-brand-greenDeep"
              data-testid="newsletter-email-input"
            />
            <button type="submit" disabled={busy} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold text-sm disabled:opacity-60" data-testid="newsletter-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Je m'inscris"}
            </button>
          </form>
          <p className="mt-2 text-[11px] text-brand-green/45">En vous inscrivant, vous acceptez de recevoir nos e-mails. Désinscription possible à tout moment.</p>
        </>
      )}
    </div>
  );
}
